/* eslint-disable max-len */

const productSurveyConfig = {
  type: 'product',
  steps: [
    {
      step: 'intro',
      body: [
        'surveyConfig.productSteps.intro.body.content1',
        'surveyConfig.productSteps.intro.body.content2',
        'surveyConfig.productSteps.intro.body.content3'
      ]
    },
    {
      step: 'isInterested',
      categories: {
        general: {
          title: 'surveyConfig.productSteps.isInterested.categories.general.title',
          options: [
            { label: 'surveyConfig.general.yes', value: 'yes', disqualify: false },
            { label: 'surveyConfig.general.maybe', value: 'maybe', disqualify: false },
            { label: 'surveyConfig.general.notRightNow', value: 'not-right-now', disqualify: false },
            { label: 'surveyConfig.general.no', value: 'no', disqualify: true },
          ]
        }
      }
    },
    {
      step: 'price.low',
      type: 'danger',
      // intro: 'surveyConfig.productSteps.price.low.intro',
      categories: {
        general: {
          body: [
            'surveyConfig.productSteps.price.low.categories.general.content1',
            'surveyConfig.productSteps.price.low.categories.general.content2',
            'surveyConfig.productSteps.price.low.categories.general.content3',
          ]
        },
      }
    },
    {
      step: 'price.high',
      type: 'danger',
      body: [
        'surveyConfig.productSteps.price.high.content1',
        'surveyConfig.productSteps.price.high.content2',
      ]
    },
  ]
};

export const quickQuestionSurveyConfig = {
  product: productSurveyConfig,
};

export type QuickQuestionCategorySurveyConfig = typeof quickQuestionSurveyConfig;
